import { Link } from "@reach/router";
import React from "react";
import { useRouteData } from "react-static";

import Layout from "../components/Layout";
import CinematicPlayer from "../components/CinematicPlayer";
import useBodyClass from "../utils/useBodyClass";

export default () => {
  const { item: cinematic } = useRouteData();

  useBodyClass("cinematic", "");
  return (
    <Layout recordLocation>
      <CinematicPlayer cinematic={cinematic} />
    </Layout>
  );
};
